/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { LoadingStateIllustration } from './assets/LoadingStateIllustration';
import messages from './i18n';

const containerStyles = cssMap({
	root: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '100%',
		backgroundColor: token('elevation.surface'),
	},
});

export interface GraphLoadingStateProps {
	testId?: string;
}

export function GraphLoadingState({
	testId = 'twg-loading-state',
}: GraphLoadingStateProps): JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<Box
			xcss={containerStyles.root}
			testId={testId}
			role="status"
			aria-label={formatMessage(messages.loadingLabel)}
			aria-busy="true"
		>
			<LoadingStateIllustration
				nodeColor={token('color.skeleton')}
				edgeColor={token('color.skeleton.subtle')}
			/>
		</Box>
	);
}
// eslint-disable-next-line @typescript-eslint/no-namespace
export declare namespace GraphLoadingState {
	export var displayName: string;
}

GraphLoadingState.displayName = 'GraphLoadingState';
